import adjustTicketTimeNumber from "./adjustTicketTimeNumber";
import millisecondsToTime from "./datetime/millisecondsToTime";
import { i18n } from "../translate/i18n";

function calculateTimeAwaitingFlag(ticket, awaitingTimeSetting) {
  const timeAwaiting = millisecondsToTime(new Date() - new Date(ticket.createdAt));

  let [timeAwaitingNumber, timeAwaitingMetric] = [parseInt(timeAwaiting.split(" ")[0]), timeAwaiting.split(" ")[1]];
  timeAwaitingNumber = adjustTicketTimeNumber(timeAwaitingNumber, timeAwaitingMetric);
  
  const secondMetrics = [i18n.t("ticketsList.timeAwaitSecond"), i18n.t("ticketsList.timeAwaitSecond") + "s"];
  return timeAwaitingNumber >= awaitingTimeSetting && !secondMetrics.includes(timeAwaitingMetric);
};

export default calculateTimeAwaitingFlag;